import ActionTextIcon from "@/components/icons/ActionTextIcon";
import Ellipsis from "@/components/views/Ellipsis";
import { cssVariables } from "@/utils/utils";
import { useState } from "react";
import { Client } from "../types";
import { ClientDetailDrawer } from "./drawers/ClientDetailDrawer";
import { ClientTypeTagWithDescription } from "./tags/ClientTypeTagWithDescription";

type Props = {
  client: Partial<Client>;
};

export const ClientLineDescription = ({ client }: Props) => {
  const [mouseOver, setMouseOver] = useState(false);
  const [detailOpen, setDetailOpen] = useState(false);

  return (
    <>
      <span
        style={{
          cursor: "pointer",
          padding: 4,
          display: "inline-flex",
          alignItems: "center",
          maxWidth: "100%",
          ...(mouseOver && { backgroundColor: cssVariables.colorHover, borderRadius: 8 }),
        }}
        onMouseEnter={() => setMouseOver(true)}
        onMouseLeave={() => setMouseOver(false)}
        onClick={() => setDetailOpen(true)}
      >
        <Ellipsis style={{ minWidth: 0 }}>
          <ClientTypeTagWithDescription client={client} />
        </Ellipsis>

        <span className="margin-left-tiny" style={{ flexShrink: 0, visibility: mouseOver ? "visible" : "hidden" }}>
          <ActionTextIcon icon="eye" color="blue" disableDelayEffect />
        </span>
      </span>

      <ClientDetailDrawer client={detailOpen ? (client as Client) : undefined} onClose={() => setDetailOpen(false)} />
    </>
  );
};
